import { TransportModesPanelMode } from 'components/RoutePlanner/TransportModesPanel'
import { Position } from 'lib/place'
import { ResultItem } from 'map/services'
import { SerializedRecentItem } from 'utils/storage'

export interface RoutePlannerState {
  error?: string
  routeWaypoints: RouteWaypoint[]
  routes: StateRoute[]
  selectedRoute?: StateRoute
  status?: RoutePlannerStatus
  routesRecentLocations: SerializedRecentItem[]
  routesAutoSuggestLocations: ResultItem[]
  selectedTransportOption?: StateRouteTransportGroup
  selectedTransportMode: TransportModesPanelMode
}

export enum RoutePlannerStatus {
  ROUTES_PENDING = 'ROUTES_PENDING',
  ROUTES_SUCCESS = 'ROUTES_SUCCESS',
  ROUTES_ERROR = 'ROUTES_ERROR',
}

export enum StateRouteTransportGroup {
  Car = 'car',
  Walk = 'walk',
  Bike = 'bicycle',
  PublicTransport = 'public-transport',
  Motorcycle = 'motorcycle',
  Taxi = 'taxi',
  Unknown = 'unknown',
}

export interface StateRoute {
  id: string
  sections: StateRouteSection[]
  distance: number
  duration: number
  arrival: string
  departure: string
  delay?: number
  attributions?: StateRouteAttributions[]
  elevationInfo?: ElevationInfo
  elevationSections?: ElevationSection[]
  elevations?: number[]
}

export interface StateRouteAttributions {
  href: string
  id: string
  text: string
  type: string
}

export interface StateRouteSection {
  id: string
  name: string
  headsign?: string
  mode: StateSectionTransportMode
  actions?: StateSectionAction[]
  intermediateStops?: StateSectionIntermediateStop[]
  color: StateSectionColor
  arrival: StateSectionArrival
  departure: StateSectionDeparture
  travelSummary: StateSectionTravelSummary
  polyline: StateSectionPolyline
  delay?: number
  spans?: StateSectionSpan[]
}

export interface StateSectionSpan {
  walkAttributes?: string[]
}

export interface StateSectionIntermediateStop {
  time: string
  location: Position
  name: string
}

export interface StateSectionColor {
  main: string
  text: string
  border: string
}

export interface StateSectionPolyline {
  value: string
  color: StatePolylineColor
}

export interface StatePolylineColor {
  main: string
  stroke: string
}

export interface StateSectionArrival {
  name?: string
  at: Position
  time: string
}

export interface StateSectionTravelSummary {
  baseDuration?: number
  duration: number
  length: number
}

export interface StateSectionDeparture {
  from: StateDeparturePlace
  time: string
  in?: number
}

export interface StateDeparturePlace {
  location: Position
  place?: string
  platform?: string
}

export interface StateSectionAction {
  name: string
  icon: string
  instruction: string
  duration: number
  length: number
  offset: number
  direction?: string
  eta?: string
  exit?: number
}

export enum StateSectionTransportMode {
  Pedestrian = 'pedestrian',
  Bike = 'bicycle',
  Train = 'train',
  Tram = 'tram',
  Subway = 'subway',
  Car = 'car',
  Bus = 'bus',
  Motorcycle = 'motorcycle',
  Taxi = 'taxi',
  Ferry = 'ferry',
  Unknown = 'unknown',
}

export interface ElevationSection {
  elevation_color: string
  elevation_data: number[]
}
export interface ElevationInfo {
  elevation_down: number
  elevation_up: number
}

export interface RouteWaypoint extends Position {
  place: string
}
